module.exports = __webpack_public_path__ + "media/images/samples/home/ep/ep6@2x-302d3b651c61f6ea5bb7642cb0a39f12.png";